import OptimizationTable from './table'

export default OptimizationTable
